module.exports = __webpack_public_path__ + "images/emoji/bread.6ffd5b548a9f1b4b3376.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bread.png
// module id = nEmB
// module chunks = 14